import React from 'react';
import { Button, Container, Row, Col, Spinner } from 'react-bootstrap'
import BudgetQn from './BudgetQn';
import CarVariantQn from './CarVariantQn';
import LeaseTermQn from './LeaseTermQn';
import DistanceQn from './DistanceQn';
import SalaryQn from './SalaryQn';
import PayCycleQn from './PayCycleQn';
import ContactDetails from './ContactDetails';
import FuelTypeQn from './FuelTypeQn';

const questions = [
    BudgetQn,
    CarVariantQn,
    FuelTypeQn,
    LeaseTermQn,
    DistanceQn,
    SalaryQn,
    PayCycleQn,
];

export default class Questions extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };

        for (let question of questions) {
            this.state[question.id] = question.defaultValue;
        }
    }

    onChange = (id, value) => {
        this.setState({ [id]: value });
    }

    onShowQuote = () => {
        const { onShowQuote, disabled, calculateBusy } = this.props;
        const contactDetails = this.contactDetails.validate();
        if (contactDetails) {
            onShowQuote(this.state, contactDetails);
        }
    }

    render() {
        const { onShowQuote, disabled, calculateBusy } = this.props;

        return (
            <>
                <div className="questions-container">
                    {questions.map((question, index) => {
                        const Component = question;
                        const id = question.id;
                        return (
                            <Component id={id} index={index + 1} key={id} value={this.state[id]} onChange={this.onChange} {...this.props} />
                        );
                    })}

                    <ContactDetails ref={(ref) => { this.contactDetails = ref; }} />

                    <div className="justify-content-md-center text-center sf-cls">
                        <Button onClick={this.onShowQuote} disabled={disabled}>
                            {calculateBusy &&
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="mr-2"
                                />
                            }
                            Show Quote
                        </Button>
                    </div>
                        
                </div>
            </>
        );
    }
}
